import React, { FC } from 'react'
import { useFormatMessage } from '@babylon/intl'
import { DateInputField } from '@babylon/medkit'
import DateInput from './DateInputWithField'
import { useLocalisation } from '@/redux/productConfig/selectors'
import messages from './DateInputWrapper.messages'
import { useConfig } from '@/redux/partnerConfig/selectors'

type DateInputPropsWithoutLabels = Omit<
  React.ComponentProps<typeof DateInputField>,
  'dayLabel' | 'monthLabel' | 'yearLabel'
>

const DateInputWrapper: FC<DateInputPropsWithoutLabels> = (
  props: DateInputPropsWithoutLabels
) => {
  const { dateFormat, language } = useLocalisation()
  const translate = useFormatMessage()
  const { useDnaV2Design } = useConfig()
  const dayLabel = translate(messages.dayLabel)
  const monthLabel = translate(messages.monthLabel)
  const yearLabel = translate(messages.yearLabel)

  if (useDnaV2Design) {
    return (
      <DateInput
        dayLabel={dayLabel}
        monthLabel={monthLabel}
        yearLabel={yearLabel}
        locale={language}
        {...props}
      />
    )
  }

  return (
    <DateInputField
      dateFormat={dateFormat}
      dayLabel={dayLabel}
      monthLabel={monthLabel}
      yearLabel={yearLabel}
      {...props}
    />
  )
}

export default DateInputWrapper
